import { useAuth0 } from '@auth0/auth0-react';
import { createAuthAction } from '../networkRequest/officialsService';
import { useUser } from '../hooks/useUser';

export const useLogout = () => {
  const { logout } = useAuth0();
  const { user } = useUser();

  const handleLogout = async () => {
    if (user) {
      await createAuthAction(user.accessToken, user.profile.id, 'logout');
      logout({ logoutParams: { returnTo: window.location.origin } });
    } else {
      // for the rare case where there was an issue retrieving a token or retrieving the user profile
      logout({ logoutParams: { returnTo: window.location.origin } });
    }
  };

  return handleLogout;
};
